import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Close from '@material-ui/icons/Close'
import { useIntl } from 'react-intl'

import LocalStorageManager from '../util/localStorageManager.js'

import logoImg from '../images/survey-logo.png'

function SurveyDialog(props) {
    const { classes, uniqueId } = props
    let localStorageManager = LocalStorageManager.getInstance()
    const [isOpen, setIsOpen] = React.useState(false)
    const intl = useIntl()

    React.useEffect(() => {
        const isCookieClicked = /isAgreeCookiePolicy=true/.test(document.cookie)
        const isLived =
            localStorageManager.deviceSettings.total_connection_count > 0
        const nextSurveyOpenTime =
            localStorageManager.deviceSettings.nextSurveyOpenTime
        const isUseEn = intl.locale === 'en'

        if (isCookieClicked && isLived && isUseEn) {
            if (
                !nextSurveyOpenTime ||
                nextSurveyOpenTime < new Date().getTime()
            ) {
                window.eventManager.sendSurveyPopupShow()
                setIsOpen(true)
            }
        }
    }, [])

    function openSurvey() {
        window.eventManager.sendSurveyPopupAnswer()
        window.open(`https://www.surveymonkey.com/r/T53QRHT?a=${uniqueId}`)
        // never open again
        // 10000 days should be enough
        localStorageManager.setSettingsCache({
            type: 'device',
            updateObj: {
                nextSurveyOpenTime: new Date().getTime() + 86400000 * 10000,
            },
        })
        setIsOpen(false)
    }
    function closeSurvey(type) {
        if (type === 'close') {
            window.eventManager.sendSurveyPopupClose()
        } else {
            window.eventManager.sendSurveyPopupClickNotNow()
        }
        const nextSurveyOpenTime =
            new Date().getTime() +
            (window.env === 'prod' ? 7 * 86400000 : 60000)
        localStorageManager.setSettingsCache({
            type: 'device',
            updateObj: {
                nextSurveyOpenTime,
            },
        })
        setIsOpen(false)
    }

    if (!isOpen) {
        return ''
    }
    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <div className={classes.iconContainer}>
                    <img className={classes.icon} src={logoImg} width="56" />
                </div>
                <div className={classes.contentContainer}>
                    <p className={classes.title}>
                        How are you enjoying WebCamera?
                    </p>
                    <p className={classes.description}>
                        Share your thoughts and help us create better
                        experience!
                    </p>
                    <div className={classes.buttonList}>
                        <button
                            className={classes.cancelBtn}
                            onClick={closeSurvey}
                        >
                            Not now
                        </button>
                        <button
                            className={classes.surveyBtn}
                            onClick={openSurvey}
                        >
                            Take a short survey
                        </button>
                    </div>
                </div>
                <button className={classes.closeByn} onClick={closeSurvey}>
                    <Close />
                </button>
            </div>
        </div>
    )
}

const styles = (theme) => ({
    root: {
        display: 'flex',
        bottom: 48,
        left: 16,
        zIndex: 99999,
        position: 'fixed',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: 2,
    },
    container: {
        width: '404px',
        height: '140px',
        boxSizing: 'border-box',
        display: 'flex',
        position: 'relative',
        padding: '16px',
    },
    iconContainer: {
        marginRight: '16px',
    },
    icon: {
        width: '56px',
        height: '56px',
    },
    contentContainer: {
        width: 264,
        textAlign: 'left',
    },
    title: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '15px',
        lineHeight: '20px',
        color: '#1A1A1A',
    },
    description: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        color: '#1A1A1A',
        marginTop: '8px',
    },
    buttonList: {
        marginTop: '16px',
    },
    cancelBtn: {
        border: '1px solid #FD9728',
        boxSizing: 'border-box',
        borderRadius: '2px',
        color: '#FD9728',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        width: '82px',
        height: '32px',
        marginRight: '8px',
        background: 'none',
        cursor: 'pointer',
    },
    surveyBtn: {
        boxSizing: 'border-box',
        borderRadius: '2px',
        background: '#FD9728',
        color: '#FFFFFF',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',
        width: '145px',
        height: '32px',
        border: 'none',
        cursor: 'pointer',
    },
    closeByn: {
        background: 'none',
        border: 'none',
        position: 'absolute',
        right: '18px',
        top: '18px',
        '& > svg': {
            width: '16px',
            height: '16px',
            stroke: 'black',
            strokeWidth: '1',
        },
        cursor: 'pointer',
    },
})

export default React.memo(withStyles(styles)(SurveyDialog))
